import { Box, FormHelperText, Grid, Typography } from "@mui/material";
import ForgotPasswordStyles from "./ForgotPassword.styles";
import CustomCard from "../../../../global/components/CustomCard/CustomCard";
import LogoIcon from "../../../../assets/icons/logo-icon.svg";
import CustomInput from "../../../../global/components/CustomInput/CustomInput";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as BackButtonIcon } from "../../../../assets/icons/ArrowLeft.svg";
import { Link } from "react-router-dom";
import history from "../../../../utils/history";
import urls from "../../../../global/constants/UrlConstants";
import React, { useState } from "react";
import strings from "../../../../global/constants/StringConstants";
import { emailInput } from "./PasswordTypesAndValidation";
import { passwordReset } from "./ForgetPasswordService";
import customErrorHandler from "../../../../utils/customErrorHandler";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../helpers/methods";
import notifiers from "../../../../global/constants/NotificationConstants";
import { motion } from "framer-motion";

const ForgotPassword = (props: any) => {
  const classes = ForgotPasswordStyles;
  const [info, setInfo] = useState(emailInput);
  const emailRegex = strings.regex;

  const handleOnChangeInputField = (event: React.ChangeEvent<any>) => {
    setInfo({
      ...info,
      [event.target.name]: {
        ...info[event.target.name],
        value: event.target.value,
      },
    });
  };

  const handleKeypress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const handleBackToLogin = () => {
    history.push(urls.loginViewPath);
  };

  const handleResetLink = async () => {
    try {
      const response = await passwordReset(info.email.value);
      customErrorHandler(response);
      openSuccessNotification(response.message);
      history.push(urls.resetPasswordLinkViewPath);
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handleKeyDowns = (e: any) => {
    if (e?.key === "Enter") {
      handleResetLink();
    }
  };

  const cardContent = () => {
    return (
      <>
        <Box onKeyDown={handleKeyDowns}>
          <Box sx={classes.cardHeader}>
            <img src={LogoIcon} alt="img" />
            <Typography sx={classes.cardTitle}>Forgot Password</Typography>
            <Typography sx={classes.cardSubText}>
              Enter the email that you used when register to recover your
              password. You will receive a password reset link.
            </Typography>
          </Box>

          <Box sx={classes.cardContent}>
            <CustomInput
              placeHolder="Email"
              id="email"
              type="email"
              name="email"
              value={info.email.value}
              onChange={handleOnChangeInputField}
              onKeyPress={handleKeypress}
              error={!!info.email.error}
              helperText={info.email.error}
            />
            {!emailRegex.test(info.email.value) &&
              info.email.value.length > 0 && (
                <FormHelperText error>
                  Please enter valid email id
                </FormHelperText>
              )}
          </Box>

          <Box sx={classes.cardFooter}>
            <CustomButton
              label="Send Reset Link"
              buttonType="primaryBtn"
              onClick={handleResetLink}
              disabled={!!info.email.error || !info.email.value} //pending
            />

            <Box
              display={"flex"}
              margin={"auto"}
              mt={"18px"}
              sx={{ pointer: "cursor" }}
            >
              <BackButtonIcon />
              <Typography onClick={handleBackToLogin} sx={classes.backToLogin}>
                Back to Login
              </Typography>
            </Box>
          </Box>
        </Box>
      </>
    );
  };

  const getForgotPassword = () => {
    return (
      <Box sx={classes.mainContentWrapper}>
        <motion.div
          initial={{ opacity: 0, filter: "blur(4px)" }}
          animate={{
            opacity: 1,
            filter: "blur(0px)",
            transition: { duration: 0.4 },
          }}
          exit={{
            opacity: 0,
            filter: "blur(4px)",
            transition: { duration: 0.4 },
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Box sx={classes.contentWrapper}>
                <CustomCard cardContent={cardContent()} />
                {/* <Box>
                  <Typography sx={classes.signUpStyle}>
                    Don't have an account? <Link to="/">Sign Up Now</Link>
                  </Typography>
                </Box> */}
              </Box>
            </Grid>
            <Grid
              item
              md={12}
              lg={12}
              position={"absolute"}
              bottom={"6px"}
              width={"100%"}
            >
              <Typography textAlign={"center"} sx={classes.disclamer}>
                © 2023, Yhataw Real Estate Facilitator. All Rights Reserved.
              </Typography>
            </Grid>
          </Grid>
        </motion.div>
      </Box>
    );
  };

  return getForgotPassword();
};

export default ForgotPassword;
